'use strict';
var KeyMirror = require('keymirror');
var ApplicationConstants = require('./ApplicationConstants.js');

module.exports = {
    ActionTypes: KeyMirror({
        UPDATE_INSPECIE_MODEL:null
    }),
    formModel: {
        setUp: ApplicationConstants.YesNoValues.NO,
        externalAccountQuestion: ''
    },
    eligibleInSpecieProducts: {
        FirstChoiceSuper: 10,
        FirstChoiceWSSuper: 11,
        FirstChoicePension: 50,
        FirstChoiceWSPension: 51,
        FirstChoiceEmployerSuper: 65
    },
    InSpecieTransferFieldMapping: {
        setUp: 'istOption',
        externalAccountQuestion: 'istExternalAccountsQuestion'
    },
    InSpecieTransferAttributes: {
        setUp: 'setUp',
        externalAccountQuestion: 'externalAccountQuestion'
    },
    Labels: { setUpInSpecieTransfer: 'Set up In-specie transfer' },
    FundingSources: KeyMirror({
        INTERNAL_NO_TD: null,
        INTERNAL_TD_AND_NON_TD: null,
        INTERNAL_TD_ONLY: null,
        INTERNAL_MANUAL: null,
        EXTERNAL: null
    })
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/InSpecieTransferConstants.js